import SubmitButtonContainer from './SubmitButton.container';
import SubmitButton from './SubmitButton';

export default SubmitButtonContainer(SubmitButton);
